import { Directive, EventEmitter, Output } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { PingService } from '@commoncore/services/ping.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { GlobalClassInstance } from '../constants/GlobalClass';
// declare var require:any;
// var clappr = require("clappr");
declare var Clappr: any;
declare var ProgressBar: any;
@Directive()
export class ClapprImplementation {

    private http:any;
    private clapprImpRef:any;
    public universalService:any;
    public audioplayer:any;
    public currentIndex:any;
    public listService:any;
    public audioPlaying:boolean = false;

    public isShufflePlayOn: boolean = false;
    public isSingleSongRepeat: boolean = false;
    public isAllSongsRepeat: boolean = false;
    public audioProgressCircle: any;
    public repeatFileIndex:any;
    //public isManualPause:boolean = false;
    private newProgressValue: any;
    private oldProgressValue: any;

    public selectedIndexValue: any = -1;
    videoPlayer

    private currentTime: any = 0;
    private seekPlayTime: any = false;
    private totalTime: any;
    public previewNotAvailable: boolean = false; 
    public playWhich: any = ""; 

    static singleInstance: any;
    containerHeightCalc:any;
    public router: any;
    localStorageService:any;

    public mediaTokenVal: any;
    public retryCount: number = 0;
    public isVideoStreamingEnd: boolean = false;
  
    @Output('previewError') isErrorInPreviewing:EventEmitter<boolean> = new EventEmitter<boolean>();
    loggerService: any;
    cleverTapEventsService: any;
    interval: any;
  // interval: NodeJS.Timeout;
    db: IndexedDBModule;
    mediaStreamUrl: string;
  pingService: any;
  dcGroupCodePicker: any;

    constructor(globalService){
        this.setHandler(globalService);
    }

    public static getInstance(globalService): ClapprImplementation {
      if (this.singleInstance == null) {
        this.singleInstance = new ClapprImplementation(globalService);
        return this.singleInstance;
      } else {
        return this.singleInstance;
      }
    }

    getClapprInstanceRef(){
        this.clapprImpRef  =  ClapprImplementation.getInstance(this.universalService);
        return this.clapprImpRef;
    }

    setHandler(globalService){
        this.http= globalService.getHttpClientRef();
        this.universalService = globalService.getUniversalServiceRef();
        this.listService = globalService.getListServiceRef();
        this.loggerService = globalService.getLoggerServiceRef();
        this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
        this.db = IndexedDBModule.getInstance(globalService);
        this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
        this.router = globalService.getRouterRef();
        this.localStorageService = globalService.getLocalStorageSvcRef();
        this.pingService = PingService.getInstance(globalService);
        this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
    }

    async openClappr() {
      var self = this;
      if(self.universalService.showMiniPlayer) {
        self.universalService.selectedFile = self.universalService.selectedAudioFile;
      }
      if(this.universalService.playAudioFromStart){
        this.universalService.isManualPause = false;
      }
      this.universalService.isManualPause = false;
      var playbackUrl = "";
      var url = "";
      var CurrUrl = window.location.href;
  //    if(this.universalService.activeRepo == 'main'){
        if(this.universalService.selectedFile["mimeType"] == 'audio'){
          playbackUrl = await this.getAudioPlaybackUrl();
        }else if(this.universalService.selectedFile["mimeType"] == 'video'){
          playbackUrl = await this.getVideoPlaybackUrl();
        }
 //     }
      if(this.universalService.selectedTab == "Shared Files" || this.universalService.selectedTab == "teamfolders"){

      }else if(this.universalService.activeRepo == 'main' && !CurrUrl.includes('/albums')){
        playbackUrl = await this.getPlayBackUrlForMainRepo();
      }else if(CurrUrl.includes('/albums')){
        if(window.location.hostname == "www.jiocloud.com"){
          url = this.universalService.selectedFile["playbackUrl"].split('boards.jiocloud.com')
        } else {
          url = this.universalService.selectedFile["playbackUrl"].split('boards.tejdrive.com')
        }
        playbackUrl = url[1];
      }else if(this.universalService.selectedFile["mimeType"] == 'video'){
        playbackUrl = await this.getVideoPlaybackUrl();
      }
      this.getPlaybackSourceUrl(playbackUrl).subscribe(
        suc => {
          if(this.universalService.isMobileDevice && this.universalService.mobilePlayList.length>0) {
            this.mobilePlaylistSelection(this.universalService.selectedFile)
          }

          self.getTokenFromMediaAuth(suc);
          this.audioplayer = this.playAudioMedia(self.mediaStreamUrl);
        },
        error=>{
          //this.isErrorInPreviewing.emit(true);
          if(this.universalService.showMiniPlayer){
            this.universalService.showToast(TOAST["MEDIA_PLAYER_ERROR"], "error")
            this.fetchFile(this.playWhich)
          }else{
            AppEvents.previewErrorEvent.next({errorValue:true,tab:this.universalService.currentTab})
            this.universalService.showErrorMessage(error);
          }
          
        }
      )
    }


    async updateDCGroupCode(url){
      let useDefaultDCCode = true;
      if(window.location.href.includes("sharedwithme")){
        await this.dcGroupCodePicker.decideTypeOfShare(this.universalService.selectedFile["shareKey"]);
        useDefaultDCCode = false;
      }else if(window.location.href.includes("?u=")){
        await this.dcGroupCodePicker.decideTypeOfShare(this.universalService.shareKey);
        useDefaultDCCode = false;
      }
      url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url,useDefaultDCCode);
      return url
    }

    async getAudioPlaybackUrl(){
        var playbackUrl = this.universalService.selectedFile["playbackUrl"];
        playbackUrl = playbackUrl.split(".com")[1];
        if(this.router.url.includes("privatefolder")){
          this.listService.getPPFToken();
          this.universalService.isPrivateFolderTokenRequired = true;
        }

        let newPlaybackUrl =  playbackUrl + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web";
        newPlaybackUrl = await this.updateDCGroupCode(newPlaybackUrl);
        // let newPlaybackUrl = playbackUrl + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web";
        return newPlaybackUrl;
    }

    async getVideoPlaybackUrl(){
        var playbackUrl = this.universalService.selectedFile["playbackUrl"];
        playbackUrl = playbackUrl.split(".com")[1];
        if(this.router.url.includes("privatefolder")){
          await this.listService.getPPFToken();
          this.universalService.isPrivateFolderTokenRequired = true;
        } 
        let newPlaybackUrl = playbackUrl + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"];
        newPlaybackUrl = await this.updateDCGroupCode(newPlaybackUrl);
        // let newPlaybackUrl = playbackUrl + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"];
        return newPlaybackUrl;
    }
    
    async getPlayBackUrlForMainRepo(){
        var file;
        if(this.router.url.includes('/memory') && this.universalService.showMiniPlayer){
          file = this.universalService.selectedAudioFile;
        }else{
          file = this.universalService.selectedFile;
        }

        file = file["FullObject"] ? file["FullObject"] : file;
        let playbackUrl = (file["playbackUrl"] && file["playbackUrl"].includes(".com")) ? file["playbackUrl"].split(".com")[1] : file["playbackUrl"];
        playbackUrl = await this.updateDCGroupCode(playbackUrl);
        // let playbackUrl ='/security/media/auth?objectKey=' + file["objectKey"];
        return playbackUrl;
    }

    getVideoPosterUrl(){
        var posterUrl = this.universalService.videoPreviewUrl["imageUrl"];
        if ($(window).width() < 1025) {
          posterUrl = this.universalService.videoPreviewUrl["imageUrl"]
        }
        return posterUrl;
    }

    getAudioPosterUrl(){
      let posterUrl = '';
      let type = this.universalService.checkIfImgTypeParamIsRequired(this.universalService.selectedAudioFile["mimeSubType"]);
      posterUrl = this.universalService.selectedAudioFile["imageTranscodeUrl"].includes("?") ? this.universalService.selectedAudioFile["imageTranscodeUrl"] + "&" : this.universalService.selectedAudioFile["imageTranscodeUrl"] + "?";
      if ($(window).width() < 1025) {
        posterUrl = posterUrl + "size=c&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
      }else{
        posterUrl = posterUrl + "size=f&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
      }
      if(this.router.url.includes('privatefolder')){
        let url = new URL(posterUrl);
        url.searchParams.delete('ppftoken');
        let token = encodeURIComponent(this.universalService.header_X_PPF_TOKEN)
        posterUrl = url+"&ppftoken="+token;

      }
      return posterUrl;
    }

    getPlaybackSourceUrl(playbackUrl){
        return this.http.get(playbackUrl, { responseType: 'text' })
    }

    videoClapprEvents(){
        let self= this;
        var top=this.universalService.videoPreviewUrl["top"]+"px";
        var width=this.universalService.videoPreviewUrl["imageWidth"]+"px";
        var height=this.universalService.videoPreviewUrl["imageHeight"]+"px";
        var left = this.universalService.videoPreviewUrl["left"]+"px";
        return  {
            onReady: function() {
                $('#video-media-content').show();
                // $('#video-media-content [data-player]').css("top",top );
                // $('#video-media-content [data-player]').css("height",height);
                // $('#video-media-content [data-player]').css("width",width);
                // $('#video-media-content [data-player]').css("left",left);
            },
            onResize: function() {
              
                // $('#video-media-content [data-player]').css("top",top );
                // $('#video-media-content [data-player]').css("height",height);
                // $('#video-media-content [data-player]').css("width",width);
                // $('#video-media-content [data-player]').css("left",left);
            },
            onPlay: function() {
              self.universalService.isStreaming = true;
              if(self.seekPlayTime) {
                self.seekPlayTime = false;
                self.videoPlayer.seek(self.currentTime);
              }

              if(self.isVideoStreamingEnd) {
                self.isVideoStreamingEnd = false;
                self.revalidateMediaStreamToken(true);
              } else {
                self.revalidateMediaStreamToken(false);
              }
            }, 
            onPause: function() { 
              self.universalService.isStreaming = false;
              self.currentTime = self.videoPlayer.getCurrentTime();
              self.updateMediaStreamTime();
            }, 
            onError: function(e) {
              console.log("player is giving eror", e);
              self.seekPlayTime = true;
              if (e.raw.code > -3 && e.raw.code < 6 || (e.raw.response.code == 401)) {
                if(e.raw.type == "networkError") {
                  self.videoPlayer.pause();
                  return;
                }
                self.videoPlayer.pause();
                self.revalidateMediaStreamToken(true);
                jQuery('.player-error-screen').remove();
              }
            },
            onTimeUpdate: function(playerTimeObj) {
              self.currentTime = playerTimeObj.current;
            },
            onStop: function() {
              self.universalService.isStreaming = false;
            },
            onEnded: function() {
              self.universalService.isStreaming = false;
              self.currentTime = 0;
              self.isVideoStreamingEnd = true;
              $('#video-media-content .player-poster[data-poster] .play-wrapper[data-poster] svg').css({
                'display': 'unset'
              });
            },
            onFullscreen: function(isFullscreen){
              
                if(isFullscreen == true){
                  self.universalService.onFullScreen = true;
                  setTimeout(()=> {
                    // self.videoPlayer.poster =  self.getVideoPosterUrl();
                    // $('#video-media-content [data-player]').css("top",0);
                    // $('#video-media-content [data-player]').css("left",0);
                  },0)
            
                } else {
                  self.universalService.onFullScreen = false;
                  setTimeout(()=> {
                    // $('#video-media-content [data-player]').css("top",top );
                    // $('#video-media-content [data-player]').css("height",height);
                    // $('#video-media-content [data-player]').css("width",width);
                    // $('#video-media-content [data-player]').css("left",left);
                  }, 0)
                }
              
            }
        }

    
    }

    audioClapprEvents(){
      var self=this;
        return {
            onReady: function() {
                //$('.audioCntnr').removeClass('hide')
                $('.audioCntnr .player-poster[data-poster] .play-wrapper[data-poster] svg path').addClass('hide')
                $('#audio-media-content [data-player]').height($('#imgover').outerHeight() - ($('.itemListContainer').height()));
                let height =$('.desktopAudioBox').height() + 160;
                let mob_height = $('.audioPosterMobile').height() + 75;
                if(self.universalService.isMobileDevice){
                  $('#audio_player [data-player]').height(mob_height.toString());
                  $('#audio_player').height(mob_height.toString());
                }else{
                  $('#audio_player [data-player]').height(height.toString());
                }
            },
            onPlay: function() {
                // clevertap.event.push("User_Media_Played", {
                //     "FILE_TYPE": "Audio",
                //     "LOCATION":cleverTapSource
                // });
                self.universalService.isStreaming = true;
                self.cleverTapEventsService.playAudio(self.universalService.currentTab)
                self.audioPlaying = true;
                if(self.seekPlayTime) {
                  self.seekPlayTime = false;
                  self.audioplayer.seek(self.currentTime);
                }
                
                if(!self.universalService.showMiniPlayer) {
                  self.revalidateMediaStreamToken(false);
                }


                $('#screenId').find('i').removeClass('NeuePlayFilled').addClass('NeuePause');
                $('.icon-audioScreenPlay').find('i').removeClass('NeuePlayFilled').addClass('NeuePause');
                $('.icon-mobilePlay').find('i').removeClass('NeuePlayFilled').addClass('NeuePause');
                $('.miniAudioScreen').find('i').removeClass('NeuePlayFilled').addClass('NeuePause');
                if ((self.audioProgressCircle == null || self.audioProgressCircle == undefined) && (self.universalService.showMiniPlayer) ) {
                  self.audioProgressCircle = new ProgressBar.Circle('.audio_progress', {
                    color: '#fff',
                    trailColor: 'transparent',
                    easing: 'easeInOut',
                    strokeWidth: 6,
                    trailWidth: 6,
                    svgStyle: null,
                    duration: 1000,
                  });
                }
                if(self.audioplayer.getCurrentTime() != undefined && self.audioplayer.getDuration() != undefined && self.universalService.showMiniPlayer) {
                  self.newProgressValue = parseFloat((self.audioplayer.getCurrentTime() / self.audioplayer.getDuration()).toFixed(2));
                  self.oldProgressValue = self.newProgressValue;
                  self.audioProgressCircle.set(self.newProgressValue);
                }
                let height =$('.desktopAudioBox').height() + 160;
                let mob_height = $('.audioPosterMobile').height() + 75;
                if(self.universalService.isMobileDevice){
                  $('#audio_player [data-player]').height(mob_height.toString());
                }else{
                  $('#audio_player [data-player]').height(height.toString());
                }
            }, 
            onPause: function() {
                self.universalService.isStreaming = false;
                self.currentTime = self.audioplayer.getCurrentTime();
                self.updateMediaStreamTime();

                if(self.universalService.showMiniPlayer && self.universalService.isManualPause == false) {
                  //self.universalService.player = this.audioplayer;
                  //self.playAudio();
                  self.universalService.isManualPause=false;
                  if(self.totalTime-self.currentTime>1){
                    self.audioPlaying = true;
                    self.audioplayer.play();
                  }
                } else {
                  this.audioPlaying = false;
                }
                
                $('#screenId').find('i').addClass('NeuePlayFilled').removeClass('NeuePause');
                $('.icon-audioScreenPlay').find('i').addClass('NeuePlayFilled').removeClass('NeuePause');
                $('.icon-mobilePlay').find('i').addClass('NeuePlayFilled').removeClass('NeuePause');
                $('.mini_player_controls').find('i').addClass('NeuePlayFilled').removeClass('NeuePause');
                $('.miniAudioScreen').find('i').removeClass('NeuePause').addClass('NeuePlayFilled');
            },
            onError: function(e) {
              console.log("player is giving eror", e);
              self.seekPlayTime = true;
              if (e.raw.code > -3 && e.raw.code < 6) {
                self.currentTime = self.audioplayer.getCurrentTime();
                self.revalidateMediaStreamToken(true);
              }
            },
            onStop: function() {
              self.universalService.isStreaming = false;
              self.clearAlbumInterval();
            },
            onSeek: function() {
              self.audioOprPerformed();
            },
            onEnded: function() {
              self.universalService.isStreaming = false;
              self.audioPlaying = false;
              self.currentTime = 0;
              self.clearAlbumInterval();
              if((self.universalService.selectedTab !='Album Details')){
               self.checkPlayOptions();
              }
              self.audioOprPerformed();
            },
            onTimeUpdate: function(playerTimeObj) {
              if (self.audioPlaying == true && (self.universalService.showMiniPlayer)) {
                self.currentTime = playerTimeObj.current
                self.totalTime = playerTimeObj.total
                self.universalService.songPosTime = self.audioplayer.getCurrentTime();
                self.newProgressValue = parseFloat((playerTimeObj.current / playerTimeObj.total).toFixed(2));
                if ($(".audio_progress").has("svg").length > 0) {
                  if (self.newProgressValue > self.oldProgressValue) {
                    self.oldProgressValue = self.newProgressValue;
                    self.audioProgressCircle.set(self.newProgressValue);
                  }
                } else {
                  self.audioProgressCircle = null;
                  self.audioProgressCircle = new ProgressBar.Circle('.audio_progress', {
                    color: '#fff',
                    trailColor: 'transparent',
                    easing: 'easeInOut',
                    strokeWidth: 6,
                    trailWidth: 6,
                    svgStyle: null,
                    duration: 100,
                  });
                }
              }
            },
        }
    }

    async playVideoMedia(sourceUrl) {
      // sourceUrl = sourceUrl.split('.com')[1];
        this.cleverTapEventsService.videoPlay();
        // var posterUrl = this.universalService.videoPreviewUrl["imageUrl"];
        // if ($(window).width() < 1025) {
        //   posterUrl = this.universalService.videoPreviewUrl["imageUrl"]
        // }
        let file = this.universalService.videoPreviewUrl ? this.universalService.videoPreviewUrl : this.universalService.selectedFile;
        var posterUrl = file["previewTranscodeUrl"];
        let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
        posterUrl = posterUrl.includes('?') ? posterUrl + '&': posterUrl + '?';
        posterUrl = posterUrl +  "size=l&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
        if(this.router.url.includes("privatefolder")){
          //await this.listService.getPPFToken();
          posterUrl = posterUrl + "&ppftoken="+ encodeURIComponent(this.universalService.header_X_PPF_TOKEN)
        }
        // }

        this.universalService.getCleverTapData();
        // let cleverTapSource = this.universalService.source;
        //this.universalService.songPosTime = 0;
        this.videoPlayer =  new Clappr.Player({
          source: sourceUrl,
          parentId: '#video-media-content',
          allowUserInteraction: true,
          border: "2px solid yellow",
          playbackNotSupportedMessage: 'Please try on a different browser',
          poster: posterUrl,
          persistConfig: true,
          isAudioOnly: false,
          autoSeekFromUrl: false,
          maxBufferLength: 5,
          closedCaptionsConfig: {
            title: 'Subtitles',
            ariaLabel: 'Closed Captions',
            labelCallback: function (track) { return track.name },
          },
          events: this.videoClapprEvents(),
        });

        AppEvents.on("FULLSCREEN", ()=> {
          if(this.videoPlayer){
            // $('#video-media-content [data-player]').css("left",0);
            $("#video-media-content [data-fullscreen]").trigger('click');
            this.containerHeightCalc.calculateHeight('.scrollableContainer',[".pseudo-header"],25)
          }
        })
        

        this.pingService.restartPingIntervalWhenSwitchingPreview();

        return this.videoPlayer;
    
    }


    playAudioMedia(sourceUrl) {
      // sourceUrl = sourceUrl.split('.com')[1];
      this.audioPlaying = false;
      const posterUrl = this.getAudioPosterUrl();
      this.universalService.getCleverTapData();
      var audioPLayerParentTag = "#audio_player";
      if ($('#audio_player').length == 0 && $('#mini_player_root').length != 0) {
        audioPLayerParentTag = "#mini_player_root";
      }

      if(this.audioplayer) {
        this.audioplayer.stop();
        this.audioplayer.destroy();
      }

        this.audioplayer =  new Clappr.Player({
          source: sourceUrl,
          autoPlay: false,
          parentId: audioPLayerParentTag,
          persistConfig: true,// added
          allowUserInteraction: true,
          autoSeekFromUrl: false,
          maxBufferLength: 5,
          playbackNotSupportedMessage: 'Please try on a different browser',
          events: this.audioClapprEvents()
        });
        //this.audioPlaying = true;
        this.universalService.player = this.audioplayer;
        // if ($("#mini_player_root").is(':visible') && !$("#audio_player").is(':visible')) {
        //   this.audioplayer.core.mediaControl.hide();
        // }

        //Autoplay if played from 'Audio filter'
        if(this.universalService.activeRepo == 'main' && this.universalService.currentTab == 'audio') {
          this.audioplayer.play();
        }else if(this.universalService.showMiniPlayer) {
          this.audioplayer.play();
        }                

        if(this.universalService.playAudioFromStart == false) {
          this.audioplayer.seek(this.universalService.songPosTime);
        }
        
        setTimeout(()=>{
          if(!this.universalService.isMobileDevice && this.universalService.activeRepo == 'main' && this.universalService.slectedRowId){
            if(this.isShufflePlayOn) {// if shuffle is on, take randomIndex
              this.listService.audioPreviewOptions.api?.ensureIndexVisible( this.selectedIndexValue);
            } else {
              this.listService.audioPreviewOptions.api?.ensureIndexVisible(this.universalService.slectedRowId);
            }
            
          }
        },500)
        
        AppEvents.optionSelected.next({audioFileUpdated : true});

        this.pingService.restartPingIntervalWhenSwitchingPreview();
        return this.audioplayer;
    }

    async playAudio(){ 
      var self = this;
      self.audioCTEvent();
        $('#screenId').find('i').removeClass('NeuePlayFilled').addClass('NeuePause');
        $('.icon-audioScreenPlay').find('i').removeClass('NeuePlayFilled').addClass('NeuePause');
        $('.miniAudioScreen').find('i').removeClass('NeuePlayFilled').addClass('NeuePause');
        $('.icon-mobilePlay').find('i').removeClass('NeuePlayFilled').addClass('NeuePause'); 
        
        // alert("play1")
        if(self.universalService.currentAlbum!=undefined && self.universalService.currentAlbum!=null){
          //setTimeout(async ()=>{
            if (self.universalService.selectedFile.recentItem == true && self.universalService.selectedPreviewFile) {
              // alert("inside if")
              await self.dragtoLastPlayedPosition();
            }
            // this.sendlastPlayedDuration();
            setTimeout(() => {
              self.audioPlaying = true;
              self.audioplayer.play(); 
            }, 1000);
            
          //},500)
        }else{
          self.audioPlaying = true;
          if(self.universalService.currentTab != 'audio' && self.universalService.isStreaming == false && self.audioplayer == undefined){
            self.universalService.isStreaming = true
            self.openClappr();
            setTimeout(() => {              
              self.audioplayer.play();               
            }, 1000);
          } else {
            setTimeout(() => {  
              if(!self.universalService.showMiniPlayer && (jQuery('#audio_player').html() == undefined || jQuery('#audio_player').html() == "")) {
                self.openClappr();
              } else {
                self.audioplayer.play(); 
              }
            }, 1000);
          }
        }
        
        
    }
    audioCTEvent(){
      this.cleverTapEventsService.playAudio(this.universalService.currentTab)
    }
    pauseAudio(){
        var albumName = this.universalService.currentAlbum?this.universalService.currentAlbum["boardName"]:""
        if(albumName != ""){
          this.cleverTapEventsService.publicAlbumMediaPaused(this.universalService.selectedFile,albumName)
        }
        $('#screenId').find('i').addClass('NeuePlayFilled').removeClass('NeuePause');
        $('.icon-audioScreenPlay').find('i').addClass('NeuePlayFilled').removeClass('NeuePause');
        $('.miniAudioScreen').find('i').addClass('NeuePlayFilled').removeClass('NeuePause');
        $('.icon-mobilePlay').find('i').addClass('NeuePlayFilled').removeClass('NeuePause');
        this.audioPlaying = false;
        if(this.audioplayer!=undefined && this.audioplayer!=null)
          this.audioplayer.pause();
        if(this.universalService.player!=undefined && this.universalService.player!=null){
          this.universalService.player.pause();
        }
        //this.audioOprPerformed();
        this.clearAlbumInterval()
    }
    
    playPauseAudio(){      
        if ($('.audioCntnr').find('i').hasClass('NeuePlayFilled') || $('.expandedMiniPlayer').find('i').hasClass('NeuePlayFilled')) {
          this.universalService.isManualPause = false;
          this.playAudio();
        } else if($('.audioCntnr').find('i').hasClass('NeuePause') || $('.expandedMiniPlayer').find('i').hasClass('NeuePause')){
          this.universalService.isManualPause = true;
          this.pauseAudio()
        }
    }
    
    listRepeat(){
        /** modify button */
  }

  songRepeat(){
      /** modify button */
  }

  noRepeat(){
      /** modify button */        
  }

  songShffle(status){
      /** modify button */        
  }

  fetchFile(value){
    this.playWhich = value
    this.pauseAudio();

    $('.audiosList .ag-row-selected').removeClass("ag-row-selected");
    if(this.universalService.player!=undefined && this.universalService.player!=null){
      this.audioplayer.stop();
      this.audioplayer.destroy();
    }
    this.loggerService.log("inside fetch file")
    var audiosList = [];
    var find;
    if(!this.universalService.isMobileDevice){
      audiosList = this.listService.rowData
      find = audiosList.find(obj => obj["FullObject"]["objectKey"] == this.universalService.selectedAudioFile["objectKey"])
    }else if(this.universalService.isMobileDevice){
      if(this.universalService.selectedTab == 'Album Details'){
        audiosList = this.universalService.albumAudioData
        find = audiosList.find(obj => obj["objectKey"] == this.universalService.selectedAudioFile["objectKey"])
      }else{
        audiosList = this.universalService.mobilePlayList
        find = audiosList.find(obj => obj["objectKey"] == this.universalService.selectedAudioFile["objectKey"])
      }
    }else{  
      audiosList = this.universalService.objectsPreviewArray
      find = audiosList.find(obj => obj["objectKey"] == this.universalService.selectedAudioFile["objectKey"])
    }
    if (this.isSingleSongRepeat) {
      this.isSingleSongRepeat = false;
      $('#repeatsong').find('i').addClass('Neuerepeat').removeClass('Neuerepeat-once').removeClass('icon-color')
    }
    this.universalService.songPosTime = 0;
    this.oldProgressValue = 0;
    if(value == "fetchNext"){
      this.fetchNextAudioFile(find)
    }else if(value == 'fetchPrevious'){
      this.fetchPreviousAudioFile(find)
    }
  }

  skipBack() {
    if(this.audioplayer.getCurrentTime() < 10) {
      this.audioplayer.seek(0);
    } else {
      this.audioplayer.seek((this.audioplayer.getCurrentTime()) - 10);
    }
  }

  skipForward() {
      this.audioplayer.seek((this.audioplayer.getCurrentTime()) + 10);
  }

  shufflePlay() {
    
    if (this.isShufflePlayOn) {
      this.isShufflePlayOn = false;
      $('#shufflesong').find('i').removeClass('icon-color');
    } else {
      this.isShufflePlayOn = true;
      $('#shufflesong').find('i').addClass('icon-color');
      if (this.isSingleSongRepeat) {
        this.isSingleSongRepeat = false;
        $('#repeatsong').find('i').addClass('Neuerepeat').removeClass('Neuerepeat-once').removeClass('icon-color')
      }
    }
  }

  repeatSongs() {
    if (this.isSingleSongRepeat) {
      this.isAllSongsRepeat = false;
      this.isSingleSongRepeat = false;
      //  $('.audioScreen').find('i').addClass('icon-Play').removeClass('icon-Pause');
      $('#repeatsong').find('i').addClass('Neuerepeat').removeClass('Neuerepeat-once').removeClass('icon-color')

    } else if (!this.isSingleSongRepeat && this.isAllSongsRepeat) {
      this.isAllSongsRepeat = false;
      this.isSingleSongRepeat = true;
      $('#repeatsong').find('i').removeClass('Neuerepeat').addClass('Neuerepeat-once');
      // let find = this.universalService.objectsPreviewArray.find(obj => obj["FullObject"]["objectKey"] == this.universalService.selectedAudioFile["objectKey"])        
      // this.repeatFileIndex = this.universalService.selectedFile;
      this.repeatFileIndex = this.universalService.selectedAudioFile;
      if (this.isShufflePlayOn) {
        this.isShufflePlayOn = false;
        $('#shufflesong').find('i').removeClass('icon-color');
      }
    } else if (!this.isSingleSongRepeat && !this.isAllSongsRepeat) {
      this.isAllSongsRepeat = true;
      this.isSingleSongRepeat = false;
      //  this.isShufflePlayOn = false;
      $('#repeatsong').find('i').addClass('icon-color');
      //$('.shffle_btn').find('i').removeClass('icon-color');
    }
  }

  checkPlayOptions() { 
    this.universalService.playAudioFromStart = true;

    if(this.universalService.player!=undefined && this.universalService.player!=null) {
      this.universalService.player.stop();
      this.universalService.player.destroy();
      this.audioplayer.stop();
      this.audioplayer.destroy();
      this.audioPlaying = false;
      if(this.universalService.currentTab != 'audio')
        this.audioplayer = undefined
    }
    if(this.isSingleSongRepeat) { //If single song repeat is selected
      if(this.universalService.currentTab == 'audio'){
        this.universalService.selectedFile = this.repeatFileIndex;
      }
      this.universalService.selectedAudioFile = this.repeatFileIndex;
      this.openClappr();
    } else if(this.isAllSongsRepeat) { //If repeat playlist is selected
      
        this.fetchFile('fetchNext');
    } else if(this.isShufflePlayOn) { //If shuffle playlist id selected
      var audiosList = [];
      var find;
      if(!this.universalService.isMobileDevice && this.listService.rowData.length > 0) { // desktop view
        audiosList = this.listService.rowData
        find = audiosList.find(obj => obj["FullObject"]["objectKey"] == this.universalService.selectedAudioFile["objectKey"])        
        var index = this.listService.rowData.indexOf(find)
        //Get the random
        var randomIndexForAudio = Math.floor(Math.random() * Math.floor(this.listService.rowData.length));
        this.universalService.selectedAudioFile = this.listService.rowData[randomIndexForAudio]["FullObject"]
        if(this.universalService.currentTab == 'audio'){
          this.universalService.selectedFile = this.universalService.selectedAudioFile        
        }
        if(this.listService.audioPreviewOptions.api){
          this.listService.audioPreviewOptions.api.ensureIndexVisible(randomIndexForAudio);    
        }
        this.selectedIndexValue  = randomIndexForAudio 
        this.universalService.audioListIndexOnPreview=this.selectedIndexValue;
      } else if(this.universalService.isMobileDevice && this.universalService.objectsPreviewArray.length > 0) { // mobile view
        audiosList = this.universalService.objectsPreviewArray
        find = audiosList.find(obj => obj["objectKey"] == this.universalService.selectedAudioFile["objectKey"])
        var index = this.universalService.objectsPreviewArray.indexOf(find)
        //Get the random
        var randomIndexForAudio = Math.floor(Math.random() * Math.floor(this.universalService.objectsPreviewArray.length));
        this.universalService.selectedAudioFile = this.universalService.objectsPreviewArray[randomIndexForAudio]
        if(this.universalService.currentTab == 'audio'){
          this.universalService.selectedFile = this.universalService.selectedAudioFile
        }
      }
      this.loggerService.log("Random file is ===>>",this.universalService.selectedAudioFile["objectName"]);
      if(($('.audiosList').find("[row-index="+(index)+"]").css("background-color")=="rgb(64, 19, 144)")) {
        $('.audiosList').find("[row-index="+(index)+"]").css("background-color", "");
      }
      $('.audiosList').find("[row-index="+(index)+"]").removeClass("audioNameSelected");
      $('.audiosList').find("[row-index="+(randomIndexForAudio)+"]").addClass("audioNameSelected");

      let settingRowSelection = false;
      if(this.listService.audioPreviewOptions.api != undefined) {
        let rowNode = this.listService.audioPreviewOptions.api.getDisplayedRowAtIndex(randomIndexForAudio);
        if(rowNode != undefined) {
          rowNode.setSelected(true);
          settingRowSelection = true;
        }
      }
      if(!settingRowSelection){
        this.openClappr();
      }
    } else if(this.universalService.currentTab == 'audio' || this.universalService.showMiniPlayer){
      this.fetchFile('fetchNext');
    }
  }

  showFullScreenAudioPlayer() {
    //this.universalService.showPreview = true;
    this.universalService.player.pause();
    //this.universalService.player.stop();
    //this.universalService.player.destroy();
    this.universalService.showMiniPlayer = false;
    this.universalService.playAudioFromStart = false;
    this.universalService.showFullViewAudioPlayer = true;
    this.universalService.openPreview(this.universalService.selectedAudioFile);
    this.db.clearStore("RecentFilesMetadata");  // refresh recent files in all files to latest previewed file
  }


  fetchPreviousAudioFile(find){
    if(!this.universalService.isMobileDevice){
      if(find){
        var index = this.listService.rowData.indexOf(find)
        if(index>=0){
          if(this.listService.rowData[index-1]){
            this.selectedIndexValue = index-1
            this.universalService.selectedAudioFile = this.listService.rowData[index-1]["FullObject"]
            this.universalService.selectedFile = this.universalService.selectedAudioFile
          }else{
            this.selectedIndexValue = 0
            this.universalService.selectedAudioFile = this.listService.rowData[0]["FullObject"]
            this.universalService.selectedFile = this.universalService.selectedAudioFile
          }
          this.universalService.audioListIndexOnPreview=this.selectedIndexValue;
          
          let settingRowSelection = false;
          if(this.listService.audioPreviewOptions.api != undefined) {
            let rowNode = this.listService.audioPreviewOptions.api.getDisplayedRowAtIndex(this.selectedIndexValue);
            if(rowNode != undefined) {
              rowNode.setSelected(true);
              settingRowSelection = true;
            }
          }


          this.loggerService.log("previous file is ===>>",this.universalService.selectedAudioFile["objectName"]);
          if(($('.audiosList').find("[row-index="+(index)+"]").css("background-color")=="rgb(64, 19, 144)")) {
            $('.audiosList').find("[row-index="+(index)+"]").css("background-color", "");
          }
          $('.audiosList').find("[row-index="+(index)+"]").removeClass("audioNameSelected");
          if(this.listService.rowData[index-1]){
            $('.audiosList').find("[row-index="+(index-1)+"]").addClass("audioNameSelected");
          } else {
            $('.audiosList').find("[row-index="+(0)+"]").addClass("audioNameSelected");
          }
          $(".audio_progress svg").remove();

          if(this.universalService.showPreview){
            this.universalService.selectedNodes = [];
            this.universalService.selectedNodes.push(this.universalService.selectedFile)
          }
          if(!settingRowSelection){
            this.openClappr();
          }
        }
      }
    }else{
      if(find){//this.universalService.mobilePlayList
        if(this.universalService.selectedTab == 'Album Details'){
          var index = this.universalService.albumAudioData.indexOf(find)
          if(index==0){
              this.universalService.selectedAudioFile = this.universalService.albumAudioData[index]
              this.universalService.selectedFile = this.universalService.selectedAudioFile
          }else if(index>=0){
            if(this.universalService.albumAudioData[index-1]){
              this.universalService.selectedAudioFile = this.universalService.albumAudioData[index-1]
              this.universalService.selectedFile = this.universalService.selectedAudioFile
            }else{
              this.universalService.selectedAudioFile = this.universalService.mobilePlayList[this.universalService.albumAudioData.length-1]
              this.universalService.selectedFile = this.universalService.selectedAudioFile
            }
          }
        }else{
          var index = this.universalService.mobilePlayList.indexOf(find)
          if(index==0){
              this.universalService.selectedAudioFile = this.universalService.mobilePlayList[index]
              this.universalService.selectedFile = this.universalService.selectedAudioFile
          }else if(index>=0){
            if(this.universalService.mobilePlayList[index-1]){
              this.universalService.selectedAudioFile = this.universalService.mobilePlayList[index-1]
              this.universalService.selectedFile = this.universalService.selectedAudioFile
            }else{
              this.universalService.selectedAudioFile = this.universalService.mobilePlayList[this.universalService.mobilePlayList.length-1]
              this.universalService.selectedFile = this.universalService.selectedAudioFile
            }
          }
        }
        this.loggerService.log("previous file is ===>>",this.universalService.selectedAudioFile["objectName"]);
        $(".audio_progress svg").remove();
        this.openClappr();
      }
    }
  }
  

   fetchNextAudioFile(find){
    let settingRowSelection = false;
    if(!this.universalService.isMobileDevice){
      if(find){
        var index = this.listService.rowData.indexOf(find)
        if(index>=0){
          if(this.listService.rowData[index+1]){
            this.selectedIndexValue = index+1
            this.universalService.selectedAudioFile = this.listService.rowData[index+1]["FullObject"];
            if(this.universalService.currentTab == 'audio'){
              this.universalService.selectedFile = this.universalService.selectedAudioFile
            }

            this.universalService.audioListIndexOnPreview=this.selectedIndexValue;

            this.loggerService.log("next file is ===>>",this.universalService.selectedAudioFile["objectName"]);
            //UI selection change
            if(($('.audiosList').find("[row-index="+(index)+"]").css("background-color")=="rgb(64, 19, 144)")) {
              $('.audiosList').find("[row-index="+(index)+"]").css("background-color", "");
            }
            $('.audiosList').find("[row-index="+(index)+"]").removeClass("audioNameSelected");
            $('.audiosList').find("[row-index="+(index+1)+"]").addClass("audioNameSelected");

            if(this.listService.audioPreviewOptions.api != undefined) {
              let rowNode = this.listService.audioPreviewOptions.api.getDisplayedRowAtIndex(this.selectedIndexValue);
              if(rowNode != undefined) {
                rowNode.setSelected(true);
                settingRowSelection = true;
              }
            }
          }else{
            this.selectedIndexValue = 0
            this.universalService.selectedAudioFile = this.listService.rowData[0]["FullObject"]
            if(this.universalService.currentTab == 'audio'){
              this.universalService.selectedFile = this.universalService.selectedAudioFile
            }

            this.universalService.audioListIndexOnPreview=this.selectedIndexValue;

            //UI selection change
            if(($('.audiosList').find("[row-index="+(index)+"]").css("background-color")=="rgb(64, 19, 144)")) {
              $('.audiosList').find("[row-index="+(index)+"]").css("background-color", "");
            }
            $('.audiosList').find("[row-index="+(index)+"]").removeClass("audioNameSelected");
            $('.audiosList').find("[row-index="+(this.selectedIndexValue)+"]").addClass("audioNameSelected");
            this.audioplayer.stop();
            this.audioplayer.destroy();

            if(this.listService.audioPreviewOptions.api != undefined) {
              let rowNode = this.listService.audioPreviewOptions.api.getDisplayedRowAtIndex(this.selectedIndexValue);
              if(rowNode != undefined) {
                rowNode.setSelected(true);
                settingRowSelection = true;
              }
            }
          }
          $(".audio_progress svg").remove();

          if(this.universalService.showPreview){
            this.universalService.selectedNodes = [];
            this.universalService.selectedNodes.push(this.universalService.selectedFile)
          }
          if(!settingRowSelection){
            this.openClappr();
          }
        }
      }
    }else{ //this.universalService.mobilePlayList
      if(find){
        if(this.universalService.selectedTab == 'Album Details'){
          var index = this.universalService.albumAudioData.indexOf(find);
          if(index>=0){
            if(this.universalService.albumAudioData[index+1]){
              this.universalService.selectedAudioFile = this.universalService.albumAudioData[index+1];
              if(this.universalService.currentTab == 'audio'){
                this.universalService.selectedFile = this.universalService.selectedAudioFile
              }
            }else{
              this.universalService.selectedAudioFile = this.universalService.albumAudioData[0];
              if(this.universalService.currentTab == 'audio'){
                this.universalService.selectedFile = this.universalService.selectedAudioFile
              }
            }
          }
        }else{
          var index = this.universalService.mobilePlayList.indexOf(find);
          if(index>=0){
            if(this.universalService.mobilePlayList[index+1]){
              this.universalService.selectedAudioFile = this.universalService.mobilePlayList[index+1]
              if(this.universalService.currentTab == 'audio'){
                this.universalService.selectedFile = this.universalService.selectedAudioFile
              }
            }else{
              this.universalService.selectedAudioFile = this.universalService.mobilePlayList[0];
              if(this.universalService.currentTab == 'audio'){
                this.universalService.selectedFile = this.universalService.selectedAudioFile
              }
            }
          }
        }
       
        $(".audio_progress svg").remove();
        this.openClappr();
      }
    }

  }

  // This is to fetch next audio if any operation is performed. Like Delete
  fetchNextAudioFileAfterOperation(currentIndex){
    if(!this.universalService.isMobileDevice){
      var index = currentIndex;
      if(index>=0){
        if(this.listService.rowData[index]){
          this.selectedIndexValue = index
          this.universalService.selectedAudioFile = this.listService.rowData[index]["FullObject"];
          if(this.universalService.currentTab == 'audio'){
            this.universalService.selectedFile = this.universalService.selectedAudioFile
          }
        }
        this.universalService.audioListIndexOnPreview=this.selectedIndexValue;

        //UI selection change
        if(($('.audiosList').find("[row-index="+(index)+"]").css("background-color")=="rgb(64, 19, 144)")) {
          $('.audiosList').find("[row-index="+(index)+"]").css("background-color", "");
        }
        $('.audiosList').find("[row-index="+(index+1)+"]").addClass("audioNameSelected");

        let settingRowSelection = false;
        if(this.listService.audioPreviewOptions.api != undefined) {
          let rowNode = this.listService.audioPreviewOptions.api.getDisplayedRowAtIndex(index+1);
          if(rowNode != undefined) {
            rowNode.setSelected(true);
            settingRowSelection = true;
          }
        }
        if(!settingRowSelection){
          this.openClappr();
        }
      }
    }else{
      var index = currentIndex;
      if(index>=0){
        if(this.universalService.mobilePlayList[index]){
          this.universalService.selectedAudioFile = this.universalService.mobilePlayList[index]
          if(this.universalService.currentTab == 'audio'){
            this.universalService.selectedFile = this.universalService.selectedAudioFile
          }
        }
      }
      $(".audio_progress svg").remove();
      this.openClappr();
    }
  }

  mobilePlaylistSelection(selectedFile){
    this.universalService.mobilePlayList.forEach(obj => {
      if(selectedFile.objectKey == obj.objectKey){
        obj["selectedItem"] = true;
      }else{
        obj["selectedItem"] = false;
      }
    })
  }
  
  dragtoLastPlayedPosition(){
    var self = this
    // this.audioplayer.seek(60);
    if (self.universalService.selectedFile.lastStreamedDuration != undefined && self.universalService.selectedFile.lastStreamedDuration != 0) {
      // $scope.notUserSeek = true;
      var seekTime = self.universalService.selectedFile.lastStreamedDuration / 1000;
      if (seekTime <= 10) {
        //setTimeout(function() {
          self.audioplayer.seek(seekTime);
        //}, 500)
      } else {
        var q = (self.universalService.selectedFile.lastStreamedDuration  / 1000) - 10;
        // alert("lastStreamedDuration q ***" + q)
        //setTimeout(function() {
          self.audioplayer.seek(q);
          // alert("seek3")
        //}, 500)
      }
    }
  }
  async audioOprPerformed(){
    
  }
  clearAlbumInterval(){
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setFileData(){
    if(this.universalService.selectedFile){
      this.universalService.cTime = this.audioplayer.getCurrentTime() * 1000; // getCurrentTime() returns time in sec 
      var lastUpdatedDate = Date.now()
      var audioData = {
        "objects": [{
          "objectKey":  this.universalService.selectedFile.objectKey,
          "boardKey": this.universalService.currentAlbum.boardKey,
          "lastStreamedDuration": this.universalService.cTime,
          "lastUpdatedDate": lastUpdatedDate
        }]
      }
    };
    return audioData
  }
  sendFileDuration(params){
    var self = this;
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["stream"]
    return new Promise(function(resolve,reject){
      self.http.put(url,params).subscribe(
          suc=>{
              resolve("SUCCESS")
          },
          err=>{
              console.log("error in send",err);
              reject(err);
          }
      )
    })
  }


  getTokenFromMediaAuth(suc) {
    this.mediaStreamUrl = '';
    let url = '';
    if(suc.includes('&token=')) {
      url = suc.split('&token=');
    } else {
      url = suc.split('?token=');
    }
    if (url[1] != undefined) {
      this.mediaStreamUrl = url[0];
      this.mediaTokenVal = url[1];
    } else {
      this.mediaStreamUrl = url[0];
    }

    if(this.universalService.activeRepo == "share") {
      this.mediaStreamUrl = suc;
    }
  }

  async revalidateMediaStreamToken(isForceCallApi) {
    var self = this;
    if (self.getTimeDifference(isForceCallApi)) {
      var playbackUrl = await self.getVideoPlaybackUrl();
      playbackUrl = playbackUrl + ((self.mediaTokenVal) ? '&tkn=' : '') + self.mediaTokenVal;
      self.getPlaybackSourceUrl(playbackUrl).subscribe(
        suc => {
          let url = suc;
          self.updateMediaStreamTime();
          self.retryCount = 0;
          if(self.seekPlayTime) {
            self.seekPlayTime = false;
            if(self.videoPlayer != undefined) {
              self.videoPlayer.seek(self.currentTime);
              self.videoPlayer.play();
            }
            if(self.audioplayer != undefined) {
              self.audioplayer.seek(self.currentTime);
              self.audioplayer.play();
            }
          }
        },
        error => {
          self.universalService.showErrorMessage(error);
          self.retryCount = 0;
        }
      )
    }
  }

  updateMediaStreamTime() {
    var tokenTime = (new Date().getTime() + ENV_CONSTANTS.constants['mediaStreamTokenExpiry']);
    if(this.universalService.selectedFile != undefined) {
      this.localStorageService.setItem(LocalStorageProps.MEDIA_STREAM_TOKEN_TIME + '_' + this.universalService.selectedFile.objectKey, tokenTime);
    }
  }

  getTimeDifference(isForceCallApi) {
    if(isForceCallApi) {
      return true;
    }
    var currentTime = new Date().getTime();
    var localTime;
    if(this.universalService.selectedFile != undefined) {
      localTime = this.localStorageService.getItem(LocalStorageProps.MEDIA_STREAM_TOKEN_TIME + '_' + this.universalService.selectedFile.objectKey);
      if (localTime == null) {
        localTime = 0;
      }
    } else {
      localTime = 0;
    }

    if (localTime < currentTime) {
      return true;
    }
    return false;
  }
}
